module.exports = __webpack_public_path__ + "static/media/YM61_2.23028840.jpg";